module.exports = __webpack_public_path__ + "imgs/background_banner.jpg";